<template>
  <v-dialog v-model="modalData.dialog" persistent max-width="650px" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="permissionCan('create')"
        color="primary"
        dark
        class="mb-2"
        :left="true"
        v-bind="attrs"
        v-on="on"
      >
        New User
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <span class="headline">{{ formTitle }} </span>
            <v-btn
              @click="handleCloseModalForm"
              style="float: right; cursor: pointer"
              icon
              color="#26223c"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="3" md="3">
            <v-select v-model="selectedLocale" :items="modalData.languages">
              <template slot="selection" slot-scope="slotProps">
                <span class="symbol symbol-20 mr-3">
                  <img :src="selectedLocale.flag" alt="" />
                </span>
                {{ slotProps.item.name }}
              </template>
              <template v-slot:item="slotProps">
                <span class="symbol symbol-20 mr-3">
                  <img :src="slotProps.item.flag" alt="" />
                </span>
                <span class="navi-text">{{ slotProps.item.name }}</span>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-select
              v-if="statuses.system && formModel"
              v-model="formModel.status"
              :items="statuses.system.user"
              label="Status"
              item-text="value"
              item-value="key"
            />
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>
        <v-form v-model="formValid" ref="form">
          <v-container v-if="formModel">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <label class="typo__label">Select Usergroups</label>
                <multiselect
                  v-model="formModel.user_groups"
                  :options="userGroups"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Pick some"
                  label="groupName"
                  track-by="id"
                  :id="dynamicID"
                >
                </multiselect>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <label class="typo__label">Select Roles</label>
                <multiselect
                  v-model="formModel.roles"
                  :options="roles"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Pick some"
                  label="name"
                  track-by="name"
                  :id="dynamicID"
                >
                </multiselect>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="formModel.christian_name1"
                  :rules="nameRules"
                  label="First name"
                  :id="dynamicID"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="formModel.christian_name2"
                  label="Middle name"
                  :id="dynamicID"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="formModel.surname"
                  :rules="nameRules"
                  label="Last name"
                  :id="dynamicID"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  :append-icon="eyeIcon"
                  v-model="formModel.password"
                  label="Password"
                  :type="passIntputType"
                  @click:append="toggleShowPass"
                  :id="dynamicID"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="formModel.locale"
                  :items="languages"
                  item-text="name"
                  item-value="lang"
                  label="Language"
                  :rules="languageRules"
                  :id="dynamicID"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="formModel.email"
                  :rules="emailRules"
                  label="Email"
                  :id="dynamicID"
                  :error-messages="messages['email']"
                  @keyup="messages['email'] = ''"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-checkbox
                  v-model="formModel.login"
                  label=" login"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-checkbox
                  v-model="formModel.newsletter"
                  label=" Newsletter"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-checkbox
                  v-model="formModel.portal"
                  label=" Portal"
                ></v-checkbox>
              </v-col>

              <v-col cols="12" sm="6" md="4"> </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="handleCloseModalForm">
          Cancel
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="handleSaveModalForm"
          v-if="
            (permissionCan('create') && this.modalData.editedIndex === -1) ||
            permissionCan('update')
          "
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import Multiselect from "vue-multiselect";
import i18nService from "@/core/services/i18n.service.js";

export default {
  name: "UserForm",
  components: { Multiselect },
  props: [
    "modalData",
    "userGroups",
    "roles",
    "statuses",
    "permissions",
    "loader",
    "messages",
  ],
  data() {
    return {
      formModel: null,
      formValid: false,
      selectedLocale: i18nService.languages.find((item) => {
        return item.lang == i18nService.getActiveLanguage();
      }),
      languages: i18nService.languages,
      eyeIcon: "mdi-eye",
      passIntputType: "password",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length > 1 || "Name must be min 2 characters",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      languageRules: [(v) => !!v || "Language is required"],
    };
  },
  mounted: function () {},
  computed: {
    dynamicID() {
      // return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());

      let text = "dynamicID";
      let chars = "abcdefghijklmnopqrstuvwxyz";

      for (let i = 0; i < 10; i++) {
        text += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      return text;
    },
    // ...mapState(["statuses"]),
    formTitle() {
      return this.modalData.editedIndex === -1 ? "New User" : "Edit User";
    },
    // formModel() {
    //   return this.modalData.editedItem;
    // },
  },

  watch: {
    modalData: {
      deep: true,
      handler(value) {
        this.selectedLocale = i18nService.languages.find((item) => {
          return item.lang == i18nService.getActiveLanguage();
        });
        this.formModel = value.editedItem;
      },
    },
  },

  methods: {
    handleCloseModalForm() {
      this.$emit("closeModalForm");
    },
    toggleShowPass() {
      if (this.eyeIcon == "mdi-eye-off") {
        this.passIntputType = "password";
        this.eyeIcon = "mdi-eye";
      } else {
        this.passIntputType = "text";
        this.eyeIcon = "mdi-eye-off";
      }
    },
    handleSaveModalForm() {
      this.$refs.form.validate();
      if (this.formValid) {
        // this.modalData.editedItem.locale = this.selectedLocale.lang;
        this.$emit("saveModalForm", Object.assign({}, this.formModel));
      }
      this.eyeIcon = "mdi-eye";
      this.passIntputType = "password";
    },
    permissionCan(action) {
      return this.permissions.find((x) => x.name == "system.user." + action);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
